import React from "react";

interface TreatmentPlanTemplateEditorAddButtonProps {
  label: string;
  onClick: () => void;
  className?: string;
}

export const TreatmentPlanTemplateEditorAddButton: React.FC<TreatmentPlanTemplateEditorAddButtonProps> = ({
  label,
  onClick,
  className = "mt-3",
}) => (
  <div className={`flex items-center justify-center cursor-pointer group/add ${className}`} onClick={onClick}>
    <div className="border-t border-interactive-primary-default flex-1 opacity-0 group-hover/add:opacity-100 transition-opacity duration-200" />
    <span className="bg-interactive-primary-default border border-interactive-primary-default rounded-xs px-2 py-1 text-xs text-white opacity-0 group-hover/add:opacity-100 transition-opacity duration-200 whitespace-nowrap">
      {label}
    </span>
    <div className="border-t border-interactive-primary-default flex-1 opacity-0 group-hover/add:opacity-100 transition-opacity duration-200" />
  </div>
);
